import React from "react";
import PropTypes from "prop-types";

const TextArea = ({
  name,
  type,
  file,
  value,
  label,
  htmlFor,
  required,
  onChange,
  textWhite,
  placeholder,
  row,
  ...props
}) => {
  return (
    <div
      className={textWhite ? "form-group text-white" : "form-group"}
    >
      <label htmlFor={htmlFor}>
        {label}
        {required ? <span className="text-danger">*</span> : null}
      </label>
      <textarea
        className={file ? "form-control-file" : "form-control"}
        type={type}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        rows={row}
        {...props}
      />
    </div>
  );
};

TextArea.propTypes = {
  file: PropTypes.any,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  htmlFor: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool.isRequired,
  textWhite: PropTypes.bool.isRequired,
  row: PropTypes.number.isRequired
};

TextArea.defaultProps = {
  type: "text"
};

export default TextArea;
